<div role="group" class="app-textarea-container">
    <textarea #textAreaElement class="app-textarea-element w-100" [formControl]="control" [rows]="rows" [maxLength]="maxLength"></textarea>
    <span *ngIf="focused" class="character-counter">{{value.length}}/{{maxLength}}</span>
</div>
